import { render, staticRenderFns } from "./CalendarWidgetItem.vue?vue&type=template&id=b54a89f4&scoped=true"
import script from "./CalendarWidgetItem.vue?vue&type=script&lang=ts"
export * from "./CalendarWidgetItem.vue?vue&type=script&lang=ts"
import style0 from "./CalendarWidgetItem.vue?vue&type=style&index=0&id=b54a89f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54a89f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54a89f4')) {
      api.createRecord('b54a89f4', component.options)
    } else {
      api.reload('b54a89f4', component.options)
    }
    module.hot.accept("./CalendarWidgetItem.vue?vue&type=template&id=b54a89f4&scoped=true", function () {
      api.rerender('b54a89f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarWidgetItem.vue"
export default component.exports